// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#welcome[data-v-115a83b6] {\n  font-size: 20px;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: white;\n}\n#welcome div img[data-v-115a83b6] {\n    width: 100%;\n    min-width: 700px;\n    margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
